import React, { useState } from "react"
import { Card, Col, Modal } from "react-bootstrap"
import { useTranslation } from "react-i18next"
import Settings from "../../../common/Settings"
import moment from "moment"

const VerificarAntecedentesListView = ({
  records,

  isLoading,
  backgroundCheck
}) => {
  const { t } = useTranslation("global")
  const [showPublicFunctionaryModal, setShowPublicFunctionaryModal] = useState(false)
  const [selectedReference, setSelectedReference] = useState("")

  const handleOpenPublicFunctionaryModal = (reference: string) => {
    setSelectedReference(reference)
    setShowPublicFunctionaryModal(true)
  }

  const handleClosePublicFunctionaryModal = () => {
    setShowPublicFunctionaryModal(false)
    setSelectedReference("")
  }
  return (
    <Col xs={12}>
      <Card className="mb-4">
        <Card.Body className="p-0 ">
          <div className="table-responsive">
            {records && records.length > 0 ? (
              <table className="table table-striped">
                <thead>
                  <tr>
                    <th></th>
                    <th>{t("Datos Generales")}</th>
                    <th>{t("Clasificación")}</th>
                    <th className="text-center">{t("Recomendaciones")}</th>
                    <th className="text-center"></th>
                  </tr>
                </thead>
                <tbody>
                  {records &&
                    records.map((record: any, index: number) => {
                      return (
                        <>
                          <tr key={index}>
                            <td>
                              {record.imagen && (
                                <img
                                  onError={(e: any) => {

                                    if (
                                      e.target.src !==
                                      "https://placehold.co/600x400"
                                    ) {
                                      e.target.src =
                                        "https://placehold.co/600x400"
                                    }
                                  }}
                                  src={"data:image/png;base64," + record.imagen}
                                  style={{
                                    minHeight: "100px",
                                    minWidth: "100px",
                                    maxWidth: "200px",
                                    maxHeight: "200px",
                                    objectFit: "cover",
                                    height: "100px",
                                    width: "100px",
                                  }}
                                  className="img-fluid img-thumbnail my-2"
                                  alt=""
                                />
                              )}
                            </td>

                            <td>
                              <b className="me-2">{t("Name")}:</b>
                              {`${record.nombres ?? ""} ${record.apellido1 ?? ""
                                } ${record.apellido2 ?? ""}`}
                              <br />
                              <b className="me-2">Cédula</b>
                              {record.cedula}
                              <br />
                              <b className="me-2">{t("Fecha de Nacimiento")}</b>
                              {record.fechaNacimiento &&
                                moment(
                                  record.fechaNacimiento.substring(0, 10)
                                ).format("DD/MM/YYYY")}
                              <br />
                              {record.alias && <>
                                <b className="me-2">{t("Alias")}</b>
                                {record.alias}
                                <br />
                              </>}
                              <b className="me-2">{t("Género")}</b>
                              {record.sexo === "M" ? "Masculino" : "Femenino"}
                              <br />
                              <b className="me-2">{t("Edad")}</b>
                              {record.edad ? Math.round(record.edad) : 0}
                            </td>
                            <td>
                              {record.padep ? <p>PADEP</p> : ""}
                              {record.publicFunctionary === true && (
                                <p
                                  className="badge bg-primary clickable"
                                  style={{ cursor: 'pointer' }}
                                  onClick={() => handleOpenPublicFunctionaryModal(record.cedula || '')}
                                  title="Click para ver referencia"
                                >
                                  Funcionario Público
                                </p>
                              )}
                            </td>

                            <td className="text-center">
                              {!record.fichado && (<>
                                <span
                                  className="badge bg-success"
                                  title={"No antencedentes judiciales"}
                                >
                                  <i className="fa fa-check me-2"></i>
                                  No antencedentes judiciales
                                </span>
                                <br />
                              </>
                              )}
                              {record.extraditado && (
                                <>
                                  <span
                                    className="badge "
                                    style={{ backgroundColor: "blue" }}
                                    title={
                                      "Solicitar certificado de no extradicción"
                                    }
                                  >
                                    <i className="fa fa-exclamation-triangle me-2"></i>
                                    Solicitar certificado de no extradicción
                                  </span>
                                  <br />
                                </>
                              )}
                              {record.fichas >= 1 && (
                                <>
                                  <span
                                    className="badge bg-danger"
                                    title={
                                      "Solicitar certificado de no antecedentes judiciales"
                                    }
                                  >
                                    <i className="fa fa-exclamation-triangle me-2"></i> Solicitar certificado de no antecedentes
                                    judiciales
                                  </span>
                                  <br />
                                </>
                              )}
                              {record.desaparecido && (
                                <>
                                  <div
                                    className="badge bg-warning  text-wrap"
                                    title={
                                      "Desaparecid@"
                                    }
                                  >
                                    <i className="fa fa-exclamation-triangle"></i>
                                    <span className="ms-2">
                                      Desaparecid@
                                    </span>
                                  </div>
                                  <br />
                                </>
                              )}

                              {record.deportado && record.deportado === true && (<><br />
                                <span
                                  className="badge "
                                  style={{ backgroundColor: "purple" }}
                                  title={
                                    "Deportado"
                                  }
                                >
                                  <i className="fa fa-exclamation-triangle me-2"></i>
                                  Solicitar Certificado de no Deportación
                                </span>
                              </>
                              )}
                              <br />
                              <div
                                className="badge bg-warning  text-wrap"
                                title={"No casos laborales"}
                              >
                                <i className="fa fa-check"></i>
                                <span className="ms-2">No casos laborales</span>
                              </div>


                            </td>
                            <td className="text-end">
                              <button className="btn btn-secondary mt-2"
                                onClick={() => {
                                  window.open(
                                    `bcr/${record.cedula}`,
                                    "_blank"
                                  )
                                }}
                              >
                                <i className="fa fa-file"></i> {t("Ver Reporte")}
                              </button>
                            </td>
                          </tr>
                        </>
                      )
                    })}

                  {records.length === 0 ? (
                    <tr>
                      <td colSpan={6} className="text-center">
                        {t("No Results")}
                      </td>
                    </tr>
                  ) : null}
                </tbody>
              </table>
            ) : (
              <div className="text-center py-2">
                <h3>{t("No records found")}</h3>
              </div>
            )}
          </div>
        </Card.Body>
      </Card>

      <Modal
        show={showPublicFunctionaryModal}
        onHide={handleClosePublicFunctionaryModal}
        size="xl"
      >
        <Modal.Header closeButton>
          <Modal.Title>{t("Referencia - Funcionario Público")}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {selectedReference && (
            <iframe
              src={`https://background-check-background-check.up.railway.app/functionaries/profile/${selectedReference}`}
              style={{
                width: '100%',
                height: '600px',
                border: 'none'
              }}
              title="Referencia Funcionario Público"
            />
          )}
          {!selectedReference && (
            <div className="text-center py-4">
              <p>{t("No reference available")}</p>
            </div>
          )}
        </Modal.Body>
      </Modal>
    </Col>
  )
}

export default VerificarAntecedentesListView
